import { combineReducers } from 'redux';

import pendingChanges from '@helsenorge/core-framework/pending-changes/pending-changes-state';
import prosesshjelp from '@helsenorge/core-framework/prosesshjelp/store';
import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { additionalPageContentApi } from '@helsenorge/framework-utils/additional-page-content';
import { tjenesteTeksterApi } from '@helsenorge/framework-utils/cms-tjeneste-tekster';
import { createLanguageReducer } from '@helsenorge/framework-utils/language';

import { resourcesApi } from '../../resources';
import registerdialogtypes from '../registre/register-dialog-types';
import registermelding from '../registre/register-melding/register-melding';
import registre from '../registre/registre';

const rootReducer = combineReducers({
  language: createLanguageReducer([LanguageLocales.NORWEGIAN, LanguageLocales.NORWEGIAN_NYNORSK]),
  [resourcesApi.reducerPath]: resourcesApi.reducer,
  prosesshjelp,
  [tjenesteTeksterApi.reducerPath]: tjenesteTeksterApi.reducer,
  [additionalPageContentApi.reducerPath]: additionalPageContentApi.reducer,
  registre,
  registerdialogtypes,
  registermelding,
  pendingChanges,
});

export default rootReducer;
